import React from 'react';
import { Box, Typography, Button, IconButton } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { useDropzone } from 'react-dropzone';
import { CloudUpload, Close } from '@material-ui/icons';
import prettyBytes from 'pretty-bytes';
import { TaskFieldsReference } from '../components/TaskFieldsReference';

const useStyles = makeStyles((theme: any) => ({
  container: {
    padding: theme.spacing(4),
    maxWidth: '800px',
    margin: '0 auto',
  },
  title: {
    fontSize: '24px',
    fontWeight: 700,
    marginBottom: theme.spacing(2),
  },
  subtitle: {
    fontSize: '14px',
    color: theme.palette.text.secondary,
    marginBottom: theme.spacing(3),
  },
  uploadContainer: {
    width: '100%',
    border: `2px dashed ${theme.palette.divider}`,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: theme.spacing(3),
    marginTop: theme.spacing(3),
    cursor: 'pointer',
    '&:hover': {
      borderColor: theme.palette.primary.main,
    },
  },
  uploadTitle: {
    fontSize: '18px',
    fontWeight: 600,
  },
  uploadSubtitle: {
    fontSize: '12px',
    color: theme.palette.text.secondary,
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: theme.spacing(4),
    gap: theme.spacing(1),
  },
}));

interface Props {
  onNext: () => void;
  onUpload: (file: any) => void;
  uploadingFile: any;
}

export function UploadFileStep({ onNext, onUpload, uploadingFile }: Props) {
  const classes = useStyles();
  const { getRootProps, getInputProps } = useDropzone();

  return (
    <Box className={classes.container}>
      <Typography className={classes.title}>Import Task Data</Typography>
      <Typography className={classes.subtitle}>
        Upload a CSV file with completed task data. The file should include profileId, taskId, and any task field
        values.
      </Typography>

      {!uploadingFile ? (
        <div {...getRootProps()} className={classes.uploadContainer}>
          <input {...getInputProps()} multiple={false} onChange={(event: any) => onUpload(event.target.files[0])} />
          <CloudUpload style={{ marginRight: '1rem', fontSize: '48px', color: '#9e9e9e' }} />
          <Box>
            <Typography className={classes.uploadTitle}>Upload CSV File</Typography>
            <Typography className={classes.uploadSubtitle}>Click or drag file to upload</Typography>
          </Box>
        </div>
      ) : (
        <div className={classes.uploadContainer}>
          <Box flex={1}>
            <Typography className={classes.uploadTitle}>{uploadingFile.name}</Typography>
            <Typography className={classes.uploadSubtitle}>{prettyBytes(uploadingFile.size)}</Typography>
          </Box>
          <IconButton onClick={() => onUpload(null)}>
            <Close />
          </IconButton>
        </div>
      )}

      <TaskFieldsReference />

      <Box className={classes.buttonContainer}>
        <Button variant='contained' color='primary' onClick={onNext} disabled={!uploadingFile}>
          Next
        </Button>
      </Box>
    </Box>
  );
}
